import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http"; import { Chart } from 'react-google-charts';
import NoData_Jupiter from "../NoData_Jupiter";
import ChartLoader_Jupiter from "../ChartLoader_Jupiter";
import BucketsTableMaxBattery_Jupiter from "./BucketsTableMaxBattery_Jupiter";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import WaterMark from "../../DashboardMain_Jupiter/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar, getElementAtEvent } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  scales
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
let Maxchartdata
let res_result

function MaxBatteryTemp_Jupiter({ apiend, gloablfilter, type }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [chartname, SetChartName] = useState("Max HV battery temp - Slow chrg");
  let barcolor
  let modal_title = "Max HV Battery Temp Slow Charge";

  const appyData = (data) => {
    res_result = data;

    let responce = {
      "<26": 0,
      "28": 0,
      "30": 0,
      "32": 0,
      "34": 0,
      "36": 0,
      "38": 0,
      "40": 0,
      "42": 0,
      ">=42": 0,
    };
    if (res_result.length === 0) {
      setChartData((prestate) => []);
    }
    if (res_result.length != 0 || res_result.BMS_Max_Cell_Temp.value != null) {
      SetApiResponce(res_result);

      let temp_result = res_result;
      let id = 0
      temp_result.map(d => {
        let value = d.BMS_Max_Cell_Temp.value

        if (value > 0 && value < 26) {
          responce["<26"] = responce["<26"] + 1;
        } else if (value >= 26 && value < 28) {
          responce["28"] = responce["28"] + 1;
        } else if (value >= 28 && value < 30) {
          responce["30"] = responce["30"] + 1;
        } else if (value >= 30 && value < 32) {
          responce["32"] = responce["32"] + 1;
        } else if (value >= 32 && value < 34) {
          responce["34"] = responce["34"] + 1;
        } else if (value >= 34 && value < 36) {
          responce["36"] = responce["36"] + 1;
        } else if (value >= 36 && value < 38) {
          responce["38"] = responce["38"] + 1;
        } else if (value >= 38 && value < 40) {
          responce["40"] = responce["40"] + 1;
        } else if (value >= 40 && value < 42) {
          responce["42"] = responce["42"] + 1;
        } else if (value >= 42) {
          responce[">=42"] = responce[">=42"] + 1;
        }
      })

      let res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys = Object.keys(responce);
      loop_keys = ["<26", "28", "30", "32", "34", "36", "38", "40", "42", ">=42"]

      let countcheck = 0
      for (const key in responce) {
        if (responce[key] > 0) {
          countcheck = countcheck + 1
        }
      }

      loop_keys.map(x => {
        if (countcheck)
          res_result_final.push([x, responce[x], `{stroke-width: 1;stroke-color: black;color:${barcolor}}`]);
      })

      const labels = ["<26", "28", "30", "32", "34", "36", "38", "40", "42", ">=42"]

      Maxchartdata = {
        labels,
        datasets: [
          {
            label: "Max Battery temp (oC)",
            data: responce,
            backgroundColor: barcolor,
            borderWidth: 1,
            borderColor: "black",
          },
        ]
      };
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }

  let hAxis = {};

  if (apiend == "rangebarchart") {
    modal_title = "Real World Range Distribution";
    hAxis = {
      gridlines: {
        color: 'transparent'
      },
      title: 'Range (Km)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    };
  }

  if (apiend == "energybarchart") {
    modal_title = "Net Energy consumption";
    hAxis = {
      gridlines: {
        color: 'transparent'
      },
      title: 'Wh/Km',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    };
  }

  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Max Battery temp (oC)'
        },
        suggestedMin: 0,
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Vehicle Count'
        },
        suggestedMin: 0,
      },
    },

    plugins: {
      legend: {
        display: false
      },
    }
  }

  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Max Battery temp (oC)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    },

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Vehicle Count',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" },
    legend: "none",
  };

  useEffect(() => {
    if (type === "Slow") {
      fetchData({ url: API_URL_MAIN + "chargingpage_jupiter/maxbatterytempslow", body: { filterdata: gloablfilter } }, appyData)
      SetChartName("Max HV battery temp - Slow chrg")
      barcolor = "#348393"
    } else {
      fetchData({ url: API_URL_MAIN + "chargingpage_jupiter/maxbatterytempfast", body: { filterdata: gloablfilter } }, appyData)
      SetChartName("Max HV battery temp - Fast chrg")
      barcolor = "#FFA650"
    }
  }, [gloablfilter, type])

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
              {
                (isLoading) ? <ChartLoader_Jupiter /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
                  : <NoData_Jupiter />
                )}
            </div>
          </div>
        </div>
      </div>
      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>

      <WaterMark />
      {(isLoading) ? <ChartLoader_Jupiter /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" width="100%" height="230px" data={chartdata} options={options} chartEvents={[
        {
          eventName: 'select',
          callback: ({ chartWrapper }) => {
            const chart = chartWrapper.getChart()
            const selection = chart.getSelection()
            if (selection.length === 1) {
              const [selectedItem] = selection;
              const { row } = selectedItem;

              const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
              const count = chartWrapper.getDataTable().Wf[row].c[1].v;
              if (count !== 0) {
                let filtered_temp = [];
                filtered_temp = apiresponce.filter(x => {
                  if (x.BMS_Max_Cell_Temp.value < barvalue && x.BMS_Max_Cell_Temp.value >= barvalue - 2) {
                    return x;
                  } else if (x.BMS_Max_Cell_Temp.value >= 42 && barvalue === ">=42") {
                    return x
                  } else if (x.BMS_Max_Cell_Temp.value < 26 && barvalue === "<26") {
                    return x
                  }
                })

                function compareObjects(object1, object2, key) {
                  const obj1 = object1.BMS_Max_Cell_Temp.value
                  const obj2 = object2.BMS_Max_Cell_Temp.value

                  if (obj1 > obj2) {
                    return -1
                  }
                  if (obj1 < obj2) {
                    return 1
                  }
                  return 0
                }

                filtered_temp.sort((value1, value2) => {
                  return compareObjects(value1, value2, 'value')
                })

                SetfilteredData(prestate => filtered_temp);
                window.$('#exampleModal__' + apiend).modal('show');
              }
            }
          }
        }
      ]}
      /> : <NoData_Jupiter />)}

      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}>
              <table className="table table-striped">
                <thead style={{ backgroundColor: '#32879c', color: '#fff' }}>
                  <tr>
                    <th scope="col">Vin Number</th>
                    <th scope="col">value</th>
                  </tr></thead>
                <tbody>
                  <BucketsTableMaxBattery_Jupiter data={filteredData} />
                </tbody></table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MaxBatteryTemp_Jupiter;